// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'flashlight-solid';

export const Component = () => (
  <path d='M17.827 2.485V3.97H7.003V2.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 8.488 1h7.855c.431 0 .766.144 1.054.431.287.288.431.623.431 1.054h-.001ZM7.002 4.927h10.824v2.539c0 .335-.096.575-.288.67L16.15 9.525a.976.976 0 0 0-.287.719v1.628c.67.239 1.005.67 1.005 1.389v1.963c0 .623-.335 1.102-1.005 1.39v5.459c0 .43-.144.766-.432 1.054a1.408 1.408 0 0 1-1.053.43H10.45a1.41 1.41 0 0 1-1.054-.43 1.408 1.408 0 0 1-.43-1.054v-11.83a.977.977 0 0 0-.288-.719l-1.39-1.389A.946.946 0 0 1 7 7.465V4.927h.002Zm8.86 10.297v-1.963c0-.335-.143-.479-.478-.479-.336 0-.48.144-.48.479v1.963c0 .335.144.48.48.48.335 0 .479-.145.479-.48Z' />
);

export const viewBox = '0 0 25 25';
